<template>
  <div>
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
      class="user-list-filters mb-8 hidden" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Name</label>

          <vs-input type="search" placeholder="Search.." v-model="filters['name']" class="mb-4 md:mb-0 w-full" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Email</label>

          <vs-input type="search" placeholder="Search.." v-model="filters['email']" class="mb-4 md:mb-0 w-full" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Contact Number</label>

          <vs-input type="search" placeholder="Search.." v-model="filters['contact_1']" class="mb-4 md:mb-0 w-full" />
        </div>

      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="" class="pt-4">
          <template slot="actions">
           
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
              class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"
              @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="name">CUOTE CODE</vs-th>
                <vs-th sort-key="email">CREATED AT</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].quote_code">
                    {{ data[indextr].quote_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>
                  
                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="PDF" position="left">
                        <vs-button @click="onClickUserEdit(data[indextr].secret_code)" color="primary" type="border" size="small"
                          icon-pack="feather" icon="icon-printer"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const CustomerRepository = RepositoryFactory.get('customer')

export default {
  name: 'SalesQuotationList',
  data() {
    return {
      selected: [],
      updateStaffSelected: [],
      options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
      popupActive: false,
      createUserPopupActive: false,
      popUpTitle: '',
      editActive: false,
      edit: null,
      editProp: {},
      checkBox1: false,
      activeConfirm: false,
      staff: [],
      selectedStaff: {},
      createStaffForm: {},
      departments: [],
      users: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [Filter],
  async mounted() {

    this.$refs.filterCard.isContentCollapsed = true
    this.$refs.filterCard.maxHeight = '1.5rem'

    this.$vs.loading()
    this.loadStaff()
    this.$vs.loading.close()

  },
  methods: {
    async onClickUserEdit(id) {
      this.$router.push(`/files/sale_quote/${id}`)
    },
    async loadStaff() {
      this.$vs.loading()
      try {
        const { data } = await CustomerRepository.getSalesQuotationList(this.page, this.filterQuery, 10, this.sort)
        this.staff = data.data
        this.meta = data.meta
        console.log(this.staff);
      } catch (error) {
        console.log(error);
      }
      this.$vs.loading.close()
    },
    filterQueryUpdate() {
      this.loadStaff()
    },

    handleChangePage(page) {
      this.page = page;
      this.loadStaff()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadStaff()
      }

    }

  },
  watch: {
    page() {
      this.loadStaff()
    }
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
